import { DATE_FORMAT } from '@utils/constants';
import dayjs from 'dayjs';

import { FlatEventGroupType } from '../models/house-history-model';

export function generateEvents(
  pages: {
    data: FlatEventGroupType;
    totalPages: number;
    currentPage: number;
    totalElements: number;
  }[]
) {
  let events: FlatEventGroupType = {};

  pages?.forEach(({ data }) => {
    Object.keys(data)?.forEach(key => {
      if (events?.[key] && Array.isArray(events?.[key])) {
        events = {
          ...events,
          [key]: [...(events?.[key] || []), ...((data as FlatEventGroupType)?.[key] || [])]
        };
      } else {
        events = {
          ...((data as FlatEventGroupType) || {}),
          ...(events || {})
        };
      }
    });
  });

  const keys = [
    ...Object.keys(events)?.sort((a, b) => {
      const [yearA, monthA, dayA] = a?.split('-');
      const [yearB, monthB, dayB] = b?.split('-');

      const sortDayA = dayjs(`${dayA}.${monthA}.${yearA}`, DATE_FORMAT);
      const sortDayB = dayjs(`${dayB}.${monthB}.${yearB}`, DATE_FORMAT);

      const diff = sortDayA.diff(sortDayB, 'day');

      return diff > 0 ? -1 : 1;
    })
  ];

  return { events, keys };
}
